import React from "react";
import { cn } from "@danishagro/shared/src/helpers/classNames.helper";
import { DA_Icon } from "@danishagro/shared/src/components/atoms/Icon/Icon.component";
import { DA_Text } from "@danishagro/shared/src/components/atoms/Text/Text.component";
import {
    DA_Title,
    DA_TitleTag,
} from "@danishagro/shared/src/components/atoms/Title/Title.component";
import { SSH_Buttons } from "../../../../../components/molecules/Buttons/Buttons.component";
import { SSH_ImageViewer } from "../../../../../components/molecules/ImageViewer/ImageViewer.component";
import { useDropdownImageSize } from "../../../../../hooks/useDropdownImageSize/useDropdownImageSize.hook";
import { DA_BasicLinkWrapper } from "./components/BasicLinkWrapper.component";
import { SpotProps } from "./Spot.interface";
import { useAlignment } from "./hooks/useAlignment.hook";
// eslint-disable-next-line css-modules/no-unused-class
import S from "./Spot.module.scss";

const Spot = (props: SpotProps) => {
    const { alignmentClass } = useAlignment(props.alignment, S);
    const { imageDropdownSizeClass } = useDropdownImageSize(props?.image?.dropdownImageSize, S);

    return (
        <div className={cn(S.wrapper, alignmentClass)}>
            {/** Image */}
            {props.image ? (
                <DA_BasicLinkWrapper
                    href={props.link}
                    target={props.target}
                    className={cn(S.link, S.imageWrapper, imageDropdownSizeClass)}
                >
                    <SSH_ImageViewer
                        src={props.image.url}
                        className={S.image}
                        aspectRatioY={200}
                        aspectRatioX={300}
                        alternative={props.image.alternative}
                    />
                </DA_BasicLinkWrapper>
            ) : null}
            {/** Icon */}
            {!props.image && props.icon ? (
                <DA_BasicLinkWrapper href={props.link} target={props.target} className={S.link}>
                    <DA_Icon name={props.icon} className={S.icon} />
                </DA_BasicLinkWrapper>
            ) : null}
            {/** Headline */}
            {props.headline ? (
                <DA_BasicLinkWrapper href={props.link} target={props.target} className={S.link}>
                    <DA_Title h3 tag={DA_TitleTag.H3} noMargin fullWidth>
                        {props.headline}
                    </DA_Title>
                </DA_BasicLinkWrapper>
            ) : null}
            {/** Text */}
            {props.text ? (
                <DA_BasicLinkWrapper
                    href={props.link}
                    target={props.target}
                    className={cn(S.link, S.textWrapper)}
                >
                    <DA_Text html={props.text} noPadding />
                </DA_BasicLinkWrapper>
            ) : null}
            {/** Buttons */}
            <SSH_Buttons buttons={props.buttons} theme={props.alternativeButtonTheme} />
        </div>
    );
};

export default Spot;
